export default __webpack_public_path__ + "static/katerhine-emeneth-f7b4ca0e58f49bf2e526fa868d27c89d.jpg";